import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IInitialStatePermissions,} from "../types";

const initialState: IInitialStatePermissions = {
    permissions: [],
    permissionsModule: [],
    permissionsTypeData:[],
    permissionTypeRole:"",
    permissionsSelectedRoleID:0,
    permissionSelectedModules:[],
    permissionsAccess:{}

}



const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        setPermissions: (state, action) => {
            state.permissions = action.payload;
        },
        setPermissionsModule: (state, action) => {
            state.permissionsModule = action.payload;
        },
        setPermissionTypeRole:(state, action) => {
            state.permissionTypeRole = action.payload;
        },
        setPermissionsTypeData: (
            state,
            action: PayloadAction<{ defaultLanguage: string; res: any[] }>
        ) => {
            const { defaultLanguage, res } = action.payload;

            state.permissionsTypeData= res
                .filter((elem: any) =>
                    elem.translations.some((translation: any) => translation.slug === defaultLanguage)
                )
                .map((elem: any) => {
                    const translation = elem.translations.find((item: any) => item.slug === defaultLanguage);
                    return {
                        id: elem.id,
                        name: translation ? translation.name : null,
                    };
                });

        },

        setPermissionSelectedRoleID:(state, action) => {
            state.permissionsSelectedRoleID = action.payload
        },
        setPermissionSelectedModules:(state, action) => {
            state.permissionSelectedModules = action.payload
        },
        setPermissionsFrontendFormat:(state, action) => {
            if(Array.isArray(action.payload.permissions)) {
                state.permissionsAccess = {}
            }
            else{
                state.permissionsAccess = action.payload.permissions
            }

        }
    },
})

export const {
    setPermissions,
    setPermissionsModule,
    setPermissionsTypeData,
    setPermissionTypeRole,
    setPermissionSelectedRoleID,
    setPermissionSelectedModules,
    setPermissionsFrontendFormat

} =permissionsSlice.actions


export default permissionsSlice